"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShortcuts = exports.ShortcutsProvider = void 0;
var Shortcuts_1 = require("./Shortcuts");
Object.defineProperty(exports, "ShortcutsProvider", { enumerable: true, get: function () { return Shortcuts_1.ShortcutsProvider; } });
Object.defineProperty(exports, "useShortcuts", { enumerable: true, get: function () { return Shortcuts_1.useShortcuts; } });
